/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ExternalProjectLinksControllerFindAllQueryResponse, ExternalProjectLinksControllerFindAllQueryParams, ExternalProjectLinksControllerFindAll401, ExternalProjectLinksControllerFindAll403 } from "../../models/externalProjectLinksController/ExternalProjectLinksControllerFindAll";

function getExternalProjectLinksControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/external-project-links` as const }  
  return res
}

/**
 * @summary List / resolve external project links
 * {@link /api/v1/external-project-links}
 */
export async function externalProjectLinksControllerFindAll(params?: ExternalProjectLinksControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ExternalProjectLinksControllerFindAllQueryResponse, ResponseErrorConfig<ExternalProjectLinksControllerFindAll401 | ExternalProjectLinksControllerFindAll403>, unknown>({ method : "GET", url : getExternalProjectLinksControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}